// hikesData.js

export const hikes = [
  {
    id: 1,
    name: "Mount Daniel & Circle Lake",
    wildernessArea: "Alpine Lakes Wilderness",
    length: 20, // miles
    dogsAllowed: true,
    highlights: "Class 2 and 3 scramble",
    permit: "Self-permit",
    distanceFromSeattle: 110, // miles
    coverPhotos: ["/images/hikes/daniel3.jpg"],
    photos: ["/images/hikes/daniel4.jpg", "images/hikes/daniel3.jpg", "images/hikes/daniel2.jpg", "images/hikes/daniel1.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/C3Y3m85lJ3k?si=ukDIFoH3W_3lHwAk",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/mount-daniel-and-peggys-pond-via-cathedral-pass-trail?u=i&sh=ud7hlu",
    coordinates: "47.4861, -121.0983"
  },
  {
    id: 2,
    name: "Mount Baker",
    wildernessArea: "North Cascades",
    length: 14, // miles
    dogsAllowed: true,
    highlights: "Roped In Glacier Travel - expertise required",
    permit: false,
    distanceFromSeattle: 120, // miles
    coverPhotos: ["/images/hikes/baker3.jpg"],
    photos: ["/images/hikes/baker1.jpg", "images/hikes/baker2.jpg", "images/hikes/baker3.jpg", "images/hikes/baker4.jpg", "images/hikes/baker5.jpg", "images/hikes/baker6.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/tN_t_plahUs?si=WKmjcE1GonhS7FdY",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/mount-baker-via-easton-glacier?u=i&sh=ud7hlu", 
    coordinates: "48.7768, -121.8147"
  },
  {
    id: 3,
    name: "Glacier Peak",
    wildernessArea: "Glacier Peak",
    length: 30, // miles
    dogsAllowed: true,
    highlights: "Roped In Glacier Travel or Class 3 Scrambling - expertise required",
    permit: "Self-Permit",
    distanceFromSeattle: 100, // miles
    coverPhotos: ["/images/glacier3.jpg"],
    photos: ["/images/hikes/glacierpeak1.jpg", "/images/hikes/glacierpeak2.jpg", "/images/hikes/glacierpeak3.jpg", "/images/hikes/glacierpeak4.jpg","/images/hikes/glacierpeak5.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/RL_lw9CEsFQ?si=nEf6xDJ2qmnxr2P8",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/glacier-peak--4?u=i&sh=ud7hlu",
    coordinates: "48.1110, -121.1110"
  },
  {
    id: 4,
    name: "Chelan Lakeshore Trail",
    wildernessArea: "Entiat Mountains",
    length: 17, // miles
    dogsAllowed: true,
    highlights: "Take a ferry to hike along this remote lakeshore",
    permit: "Ferry Reservation",
    distanceFromSeattle: 200, // miles
    coverPhotos: ["/images/hikes/chelanlakeshore1.jpg"],
    photos: ["/images/hikes/chelanlakeshore1.jpg","/images/hikes/chelanlakeshore3.jpg","/images/hikes/chelanlakeshore2.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/W2VVr-54P-U?si=8ScMIWgN9rXjQTzu",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/chelan-lakeshore-trail-prince-creek-campground-to-stehekin?u=i&sh=ud7hlu",
    coordinates: "47.8700, -120.6780"
  },
  {
    id: 5,
    name: "Golden Ears",
    wildernessArea: "Golden Ears",
    length: 20, // miles
    dogsAllowed: true,
    highlights: "Cross over into Canada for this delightful summit, and sleep on top of platforms above the lakes below",
    permit: "BC Parks Backcountry Permit",
    distanceFromSeattle: 180, // miles
    coverPhotos: ["/images/hikes/goldenears3.jpg"],
    photos: ["/images/hikes/goldenears1.jpg", "/images/hikes/goldenears2.jpg", "/images/hikes/goldenears3.jpg","/images/hikes/goldenears4.jpg", "/images/hikes/goldenears5.jpg","/images/hikes/goldenears6.jpg","/images/hikes/goldenears7.jpg","/images/hikes/goldenears8.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/kjVNye2uVUs?si=W57Ic-5rBwI5_GM8",
    allTrails: "https://www.alltrails.com/widget/trail/canada/british-columbia/golden-ears-trail?u=i&sh=ud7hlu",
    coordinates: "49.3660, -122.5040"
  },
  {
    id: 6,
    name: "Abernathy Peak, Scatter Lake",
    wildernessArea: "Methow/Sawtooth",
    length: 12, // miles
    dogsAllowed: true,
    highlights: "Scramble up this scree covered class three peak, and camp and the peaceful Scatter Lake with the mountain goats",
    permit: "None",
    distanceFromSeattle: 250, // miles
    coverPhotos: ["/images/hikes/abernathy1.jpg"],
    photos: ["/images/hikes/abernathy1.jpg", "/images/hikes/abernathy2.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/mDMWxQ8SSHc?si=f4N1i347DKnywDhP",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/scatter-lake?u=i&sh=ud7hlu",
    coordinates: "48.434462101672864, -120.52041014035836"
  },
  {
    id: 7,
    name: "Welcome Pass",
    wildernessArea: "North Cascades",
    length: 5, // miles
    dogsAllowed: true,
    highlights: "Scramble up this short but beautiful trail and spread out on High Divide, with Mount Baker right there.",
    permit: "None",
    distanceFromSeattle: 150, // miles
    coverPhotos: ["/images/hikes/welcomepass2.jpg"],
    photos: ["/images/hikes/welcomepass1.jpg", "/images/hikes/welcomepass2.jpg", "/images/hikes/welcomepass3.jpg", "/images/hikes/welcomepass4.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/qYvBYYy50e8?si=x1fM3mUWXZBvX2zp",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/welcome-pass-via-high-divide-trail?u=i&sh=ud7hlu",
    coordinates: "48.96474239956182, -121.70869578183684"
  },
  {
    id: 8,
    name: "Wing Lake, Black Peak",
    wildernessArea: "North Cascades",
    length: 15, // miles
    dogsAllowed: true,
    highlights: "Scramble up this scree covered class three peak, and camp and the gorgeous Wing Lake among the Larches",
    permit: "None",
    distanceFromSeattle: 200, // miles
    coverPhotos: ["/images/hikes/winglake5.jpg"],
    photos: ["/images/hikes/winglake1.jpg", "/images/hikes/winglake2.jpg", "/images/hikes/winglake3.jpg", "/images/hikes/winglake4.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/h0_UPXHUEXE?si=PW5EzfHlYowTZkLZ",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/maple-pass-to-wing-lake-and-black-peak?u=i&sh=ud7hlu",
    coordinates: "48.53399862325879, -120.73647806815778"
  },
  {
    id: 9,
    name: "Yellow Aster Butte",
    wildernessArea: "North Cascades",
    length: 10, // miles
    dogsAllowed: true,
    highlights: "Wonderful hike for all ages, camp among the tarns just below Yellow Aster Butte",
    permit: "None",
    distanceFromSeattle: 150, // miles
    coverPhotos: ["/images/hikes/yellowaster1.jpg"],
    photos: ["/images/hikes/yellowaster2.jpg", "/images/hikes/yellowaster3.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/qYvBYYy50e8?si=x1fM3mUWXZBvX2zp",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/yellow-aster-butte-trail?u=i&sh=ud7hlu",
    coordinates: "48.96474239956182, -121.70869578183684"
  },
  {
    id: 10,
    name: "Lake Edna",
    wildernessArea: "Central Cascades",
    length: 12, // miles
    dogsAllowed: true,
    highlights: "A less-traveled hike that climbs quickly and rewards with a serene alpine lake",
    permit: "None",
    distanceFromSeattle: 150, // miles
    coverPhotos: ["/images/hikes/edna1.jpg"],
    photos: ["/images/hikes/edna2.jpg", "/images/hikes/edna3.jpg"],
    youtubeVideo: "",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/lake-edna-trail?u=i&sh=ud7hlu",
    coordinates: "47.65923537817634, -120.88909158190356"
  },
  {
    id: 11,
    name: "Bean Creek Basin & Bean Peak",
    wildernessArea: "Central Cascades",
    length: 8, // miles
    dogsAllowed: true,
    highlights: "A great early-season hike while the rest of the state thaws out. Scramble up Bean Peak for views of the enchantments",
    permit: "None",
    distanceFromSeattle: 110, // miles
    coverPhotos: ["/images/hikes/beanpeak5.jpg"],
    photos: ["/images/hikes/beanpeak1.jpg", "/images/hikes/beanpeak3.jpg", "/images/hikes/beanpeak2.jpg", "/images/hikes/beanpeak4.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/pO6FdPXZls8?si=VbuFjdJz2iWX8yGk",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/bean-creek-basin?u=i&sh=ud7hlu",
    coordinates: "47.47399407554839, -120.88963269180176"
  },
  {
    id: 12,
    name: "Eagle Lakes",
    wildernessArea: "Methow/Sawtooth",
    length: 13, // miles
    dogsAllowed: true,
    highlights: "Looking for a larch-march? Eagle Lakes is worth the long drive. Bring a fishing pole for peak fun!",
    permit: "None",
    distanceFromSeattle: 230, // miles
    coverPhotos: ["/images/hikes/eaglelakes2.jpg"],
    photos: ["/images/hikes/eaglelakes3.jpg", "/images/hikes/eaglelakes4.jpg", "/images/hikes/eaglelakes5.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/4Ew9Fie_Dks?si=DDsloIXUEM1W1aar",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/eagle-lakes-trail--2?u=i&sh=ud7hlu",
    coordinates: "48.29704602736216, -120.27076216328486"
  },
  {
    id: 16,
    name: "Baldy Peak",
    wildernessArea: "Olympics",
    length: 8, // miles
    dogsAllowed: true,
    highlights: "A less-traveled hike that climbs quickly and rewards with a open views over the Olympics",
    permit: "None",
    distanceFromSeattle: 150, // miles
    coverPhotos: ["/images/hikes/baldy1.jpg"],
    photos: ["/images/hikes/baldy2.jpg", "/images/hikes/baldy3.jpg", "/images/hikes/baldy4.jpg", "/images/hikes/baldy5.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/F8QmlN0mWPI?si=idDYQSi-oKmKgagI",
    coordinates: "47.8829, -123.1427"
  },
  {
    id: 17,
    name: "Barclay Lake",
    wildernessArea: "Central Cascades",
    length: 5, // miles
    dogsAllowed: true,
    highlights: "A perfect family friendly day hike or first-time backpacking trip",
    permit: "None",
    distanceFromSeattle: 80, // miles
    coverPhotos: ["/images/hikes/barclay1.jpg"],
    photos: ["/images/hikes/barclay2.jpg", "/images/hikes/barclay3.jpg", "/images/hikes/barclay4.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/giCEsdDNZj0?si=Eayb6DBGRU5DtTbQ",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/barclay-lake-trail?u=i&sh=ud7hlu",
    coordinates: "47.80708345131732, -121.4559473021496"
  },
  {
    id: 13,
    name: "Columbia River Gorge",
    wildernessArea: "Southern Washington",
    length: 5, // miles
    dogsAllowed: true,
    highlights: "Looking for wildflowers and an early-season day hike? Check out the Columbia River Gorge!",
    permit: "None",
    distanceFromSeattle: 80, // miles
    coverPhotos: ["/images/hikes/columbia5.jpg"],
    photos: ["/images/hikes/columbia1.jpg", "/images/hikes/columbia3.jpg", "/images/hikes/columbia4.jpg", "/images/hikes/columbia5.jpg", "/images/hikes/columbia6.jpg", "/images/hikes/columbia7.jpg"],
    youtubeVideo: "",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/columbia-river-gorge?u=i&sh=ud7hlu",
    coordinates: "45.57260134546831, -122.31381150889011"
  },
  {
    id: 14,
    name: "Cutthroat Pass",
    wildernessArea: "North Cascades",
    length: 12, // miles
    dogsAllowed: true,
    highlights: "Experience a day or two of North Cascades goodness on the PCT from Rainy Pass off Highway 20",
    permit: "None",
    distanceFromSeattle: 150, // miles
    coverPhotos: ["/images/hikes/cutthroat1.jpg"],
    photos: ["/images/hikes/cutthroat2.jpg", "/images/hikes/cutthroat3.jpg", "/images/hikes/cutthroat4.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/7s5W8BCihMw?si=yFa784hlnf1BEXB8",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/cutthroat-pass-via-the-pct?u=i&sh=ud7hlu",
    coordinates: "48.55519024588466, -120.72823972425736"
  },
  {
    id: 15,
    name: "The Enchantments",
    wildernessArea: "Alpine Lakes Wilderness",
    length: 20, // miles
    dogsAllowed: false,
    highlights: "Possibly Washington's most famous hike. Enter the lottery to obtain a permit, and you won't forget it!",
    permit: "None",
    distanceFromSeattle: 150, // miles
    coverPhotos: ["/images/hikes/enchantments1.jpg"],
    photos: ["/images/hikes/enchantments2.jpg", "/images/hikes/enchantments3.jpg", "/images/hikes/enchantments4.jpg", "/images/hikes/enchantments5.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/gUbGl3ILEJ0?si=1mH8-QRUdr7on5S5",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/the-enchantments-trail?u=i&sh=ud7hlu",
    coordinates: "47.48178173451093, -120.8173252816555"
  },
  {
    id: 18,
    name: "Mount St. Helens",
    wildernessArea: "Mt. St. Helens",
    length: 10, // miles
    dogsAllowed: false,
    highlights: "This hike is a little easier than it was in 1979. Climb an active volcano and look down on the crater!",
    permit: "Required",
    distanceFromSeattle: 150, // miles
    coverPhotos: ["/images/hikes/helens1.jpg"],
    photos: ["/images/hikes/helens2.jpg", "/images/hikes/helens3.jpg", "/images/hikes/helens4.jpg", "/images/hikes/helens5.jpg", "/images/hikes/helens6.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/lSVY447Dgyk?si=k9YK5W9mBbcsAPYy",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/mount-saint-helens-via-worm-flows-trail?u=i&sh=ud7hlu",
    coordinates: "46.14800512806489, -122.18356603007554"
  },
  {
    id: 19,
    name: "Old Snowy, Goat Lake",
    wildernessArea: "Goat Rocks Wilderness",
    length: 17, // miles
    dogsAllowed: true,
    highlights: "Goat Rocks is a must-visit. Unlike forested mountains in the North Cascades, experience expansive views right out of the car.",
    permit: "Self-Permit",
    distanceFromSeattle: 150, // miles
    coverPhotos: ["/images/hikes/goatrocks2.jpg"],
    photos: ["/images/hikes/goatrocks1.jpg", "/images/hikes/goatrocks3.jpg", "/images/hikes/goatrocks4.jpg", "/images/hikes/goatrocks5.jpg"],
    youtubeVideo: "",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/old-snowy-mountain-via-snowgrass-trail?u=i&sh=ud7hlu",
    coordinates: "46.539391302499496, -121.44812890814511"
  },
  {
    id: 20,
    name: "High Rock Lookout",
    wildernessArea: "South Cascades",
    length: 4, // miles
    dogsAllowed: true,
    highlights: "Looking for a quick after-work hike? This will get you right up in front of Mount Rainier and quickly",
    permit: "false",
    distanceFromSeattle: 100, // miles
    coverPhotos: ["/images/hikes/highrock1.jpg"],
    photos: ["/images/hikes/highrock2.jpg", "/images/hikes/highrock3.jpg", "/images/hikes/highrock4.jpg", "/images/hikes/highrock5.jpg"],
    youtubeVideo: "",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/high-rock-lookout-trail?u=i&sh=ud7hlu",
    coordinates: "46.726247318618086, -121.89810686965252"
  },
  {
    id: 21,
    name: "Kelly Butte",
    wildernessArea: "Mt. Rainier Area",
    length: 4, // miles
    dogsAllowed: true,
    highlights: "Looking for a quick after-work hike? This will get you right up in front of Mount Rainier and quickly, the perfect date spot.",
    permit: "false",
    distanceFromSeattle: 100, // miles
    coverPhotos: ["/images/hikes/kelly1.jpg"],
    photos: ["/images/hikes/kelly2.jpg", "/images/hikes/kelly3.jpg", "/images/hikes/kelly4.jpg", "/images/hikes/kelly5.jpg"],
    youtubeVideo: "",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/kelly-butte-trail-1031?u=i&sh=ud7hlu",
    coordinates: "47.20767886299854, -121.48915667751928"
  },
  {
    id: 22,
    name: "Lyman Lake & Spider Gap",
    wildernessArea: "Entiat Mountains",
    length: 21, // miles
    dogsAllowed: true,
    highlights: "This hike just gets better and better! After leaving the car, you will feel miles from civilization. Be sure to take a dip in the glacier water",
    permit: "Self-permit",
    distanceFromSeattle: 150, // miles
    coverPhotos: ["/images/hikes/lyman1.jpg"],
    photos: ["/images/hikes/lyman2.jpg", "/images/hikes/lyman3.jpg", "/images/hikes/lyman4.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/5VBIEcwxFn8?si=iW51SObAG3ShqXV1",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/phelps-creek-trail-to-lyman-lake?u=i&sh=ud7hlu",
    coordinates: "48.2074064047681, -120.86567011219859"
  },
  {
    id: 23,
    name: "Navaho Peak",
    wildernessArea: "Snoqualmie Region",
    length: 14, // miles
    dogsAllowed: true,
    highlights: "Rewarding summit views, camp up on the ridge for views of the Enchantments! ",
    permit: "None",
    distanceFromSeattle: 12, // miles
    coverPhotos: ["/images/hikes/navaho4.jpg"],
    photos: ["/images/hikes/navaho2.jpg", "/images/hikes/navaho3.jpg", "/images/hikes/navaho1.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/bet9iFIxsfA?si=WM2g8EWlT4D33n31",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/navaho-peak?u=i&sh=ud7hlu",
    coordinates: "47.39089574323077, -120.87197778180355"
  },
  {
    id: 24,
    name: "Raven Lake",
    wildernessArea: "Mountain Loop Highway",
    length: 8, // miles
    dogsAllowed: true,
    highlights: "Good luck finding this one! Off-trail below White Chuck Mountain is a beautiful pristine lake.",
    permit: "None",
    distanceFromSeattle: 80, // miles
    coverPhotos: ["/images/hikes/raven1.jpg"],
    photos: ["/images/hikes/raven1.jpg", "/images/hikes/raven2.jpg"],
    youtubeVideo: "",
    coordinates: "48.2216393989131, -121.44169846749594"
  },
  {
    id: 25,
    name: "Alice and Toxaway Lakes",
    wildernessArea: "Sawtooth Wilderness",
    length: 8, // miles
    dogsAllowed: true,
    highlights: "The Sawtooth Wilderness in Idaho is a must-visit. Unlike forested mountains in the North Cascades, experience expansive views right out of the car.",
    permit: "None",
    distanceFromSeattle: 400, // miles
    coverPhotos: ["/images/hikes/sawtooths1.jpg"],
    photos: ["/images/hikes/sawtooths2.jpg", "/images/hikes/sawtooths3.jpg", "/images/hikes/sawtooths4.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/YBhdPGa0M80?si=JW32lNDDSmRY81bI",
    allTrails: "https://www.alltrails.com/widget/trail/us/idaho/tin-cup-hiker?u=i&sh=ud7hlu",
    coordinates: "44.11457505771481, -114.9683185342066"
  },
  {
    id: 26,
    name: "South Kaibab to Bright Angel",
    wildernessArea: "Grand Canyon National Park",
    length: 19, // miles
    dogsAllowed: false,
    highlights: "Experience the Grand Canyon from both the rim and the river in one day. This is a bucket list hike!",
    permit: "None",
    distanceFromSeattle: 1200, // miles
    coverPhotos: ["/images/hikes/grandcanyon1.jpg"],
    photos: ["/images/hikes/grandcanyon2.jpg", "/images/hikes/grandcanyon3.jpg", "/images/hikes/grandcanyon4.jpg", "/images/hikes/grandcanyon5.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/9YppPsLbJms?si=HHNlKnqkfmh9qZBl",
    allTrails: "https://www.alltrails.com/widget/trail/us/arizona/south-kaibab-to-north-kaibab-to-bright-angel-trail?u=i&sh=ud7hlu",
    coordinates: "36.1069, -112.1129"
  },
  {
    id: 27,
    name: "Glacier Lake",
    wildernessArea: "Alpine Lakes Wilderness",
    length: 11, // miles
    dogsAllowed: true,
    highlights: "Scramble down to a beautiful lake with a waterfall flowing into it, and try the scramble up to Chickamin Peak",
    permit: "None",
    distanceFromSeattle: 70, // miles
    coverPhotos: ["/images/hikes/glacier10.jpg"],
    photos: ["/images/hikes/glacier20.jpg", "/images/hikes/glacier30.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/U0C6nXE8-zI?si=ox575iIu8yRYoGfk",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/spectacle-lake-via-mineral-creek-trail?u=i&sh=ud7hlu",
    coordinates: "47.46743386612598, -121.29493152626712"
  },
  {
    id: 28,
    name: "Chiwawa Mountain",
    wildernessArea: "Glacier Peak Wilderness",
    length: 13, // miles
    dogsAllowed: true,
    highlights: "This is a very difficult and unmarked scramble, but the views are worth it!",
    permit: "Self-permit",
    distanceFromSeattle: 70, // miles
    coverPhotos: ["/images/hikes/chiwawa3.jpg"],
    photos: ["/images/hikes/chiwawa1.jpg", "/images/hikes/chiwawa2.jpg", "/images/hikes/chiwawa4.jpg", "/images/hikes/chiwawa3.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/xEGzUOrT_pA?si=LoZBDou1gxK7HuvW",
    coordinates: "48.19949958243549, -120.90136562066812"
  },
  {
    id: 29,
    name: "Camp Muir",
    wildernessArea: "Mount Rainier National Park",
    length: 10, // miles
    dogsAllowed: true,
    highlights: "A long day hike that can be done year round, but be prepared for snow and ice",
    permit: "Self-permit",
    distanceFromSeattle: 100, // miles
    coverPhotos: ["/images/hikes/muir1.jpg"],
    photos: ["/images/hikes/muir2.jpg", "/images/hikes/muir3.jpg", "/images/hikes/muir4.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/JUtlsWETtGA?si=S9ynoSm9fvhDuFKu",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/camp-muir-route-via-skyline-trail?u=i&sh=ud7hlu",
    coordinates: "46.856063773000244, -121.72987611879736"
  },
  {
    id: 30,
    name: "Tuck and Robin Lakes",
    wildernessArea: "Alpine Lakes Wilderness",
    length: 14, // miles
    dogsAllowed: true,
    highlights: "This is one of Washington's most popular hikes, and for good reason. The lakes are stunning!",
    permit: "Self-permit",
    distanceFromSeattle: 100, // miles
    coverPhotos: ["/images/hikes/tuck1.jpg"],
    photos: ["/images/hikes/tuck2.jpg", "/images/hikes/tuck3.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/sBT-Un_1nFA?si=0QBca5sO1uQDinaG",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/tuck-and-robin-lakes?u=i&sh=ud7hlu",
    coordinates: "47.59338908211972, -121.09580058039253"
  },
  {
    id: 31,
    name: "Ice Lakes",
    wildernessArea: "Glacier Peak Wilderness",
    length: 15, // miles
    dogsAllowed: true,
    highlights: "If you're looking for a larch march with lakes to camp by, this late-season hike is perfect!",
    permit: "Self-permit",
    distanceFromSeattle: 100, // miles
    coverPhotos: ["/images/hikes/ice3.jpg"],
    photos: ["/images/hikes/ice1.jpg", "/images/hikes/ice2.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/B9F0N9k_RPQ?si=weohmFdxm-E6qxGp",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/mount-maude-via-phelps-creek-trail?u=i&sh=ud7hlu",
    coordinates: "48.08323052744559, -120.83454746867723"
  },
  {
    id: 32,
    name: "Bathtub Lakes",
    wildernessArea: "Mt Pilchuck State Park",
    length: 12, // miles
    dogsAllowed: true,
    highlights: "The trail ends at Pinnacle Lake, but that doesn't mean the adventure does. Continue up a waterfall into the Bathtub Lakes valley",
    permit: "None",
    distanceFromSeattle: 70, // miles
    coverPhotos: ["/images/hikes/bathtub1.jpg"],
    photos: ["/images/hikes/bathtub1.jpg", "/images/hikes/bathtub2.jpg", "/images/hikes/bathtub3.jpg", "/images/hikes/bathtub4.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/MqzGO8W8rjA?si=rlFNVq_hVrzDZKer",
    allTrails: "https://www.alltrails.com/widget/poi/us/washington/granite-falls/bathtub-lakes?u=i&sh=ud7hlu",
    coordinates: "48.05856,-121.73623"
  },
  {
    id: 33,
    name: "Lake Ann - Esmerelda Basin",
    wildernessArea: "Okanogan-Wenatchee National Forest",
    length: 9, // miles
    dogsAllowed: true,
    highlights: "The hike is gradual and straightforward, head up over the pass then down to Lake Ann.",
    permit: "None",
    distanceFromSeattle: 115, // miles
    coverPhotos: ["/images/hikes/ann2.jpg"],
    photos: ["/images/hikes/ann1.jpg", "/images/hikes/ann2.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/JXxXnQr0jpY?si=XO2IXTm9gNY51DuA",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/lake-ann-via-esmerelda-basin-trail?u=i&sh=ud7hlu",
    coordinates: "47.43675,-120.93686"
  },
  {
    id: 34,
    name: "Surprise Lake, Surprise Mountain",
    wildernessArea: "Alpine Lakes Wilderness",
    length: 15, // miles
    dogsAllowed: true,
    highlights: "Great fishing, fun scramble route up to a premier view of the Alpine Lakes Wilderness",
    permit: "None",
    distanceFromSeattle: 115, // miles
    coverPhotos: ["/images/hikes/surprise2.jpg"],
    photos: ["/images/hikes/surprise1.jpg", "/images/hikes/surprise2.jpg", "/images/hikes/surprise3.jpg", "/images/hikes/surprise4.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/hLnTWQRqfnE?si=x4o1g3WIB6pQ5GeW",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/surprise-creek-trail-to-surprise-and-glacier-lakes?u=i&sh=ud7hlu",
    coordinates: "47.7086,-121.15466"
  },
  {
    id: 35,
    name: "Goat Lake, Ptarmigan Ridge",
    wildernessArea: "Mount Baker Area",
    length: 10.5, // miles
    dogsAllowed: true,
    highlights: "Stunning views of Mount Baker with minimal elevation gain. Rocky trail with lupine and sedges. Access to beautiful green Goat Lake.",
    permit: "Northwest Forest Pass",
    distanceFromSeattle: 158, // miles
    coverPhotos: ["/images/hikes/goat2.jpg"],
    photos: ["/images/hikes/goat1.jpg", "/images/hikes/goat2.jpg", "/images/hikes/goat3.jpg"],
    youtubeVideo: "",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/ptarmigan-ridge?u=i&sh=ud7hlu",
    coordinates: "48.8463, -121.6927"
  },
  {
    id: 36,
    name: "Cyclone Lake, Snowking Mountain",
    wildernessArea: "North Cascades",
    length: 16, // miles
    dogsAllowed: true,
    highlights: "Strenuous mountaineering trip or class 3 alpine scramble with stunning panoramic mountain views, deep blue alpine lakes and rewarding isolation.",
    permit: "Wilderness permit. Self-issue at trailhead (no fee)",
    distanceFromSeattle: 100, // miles
    coverPhotos: ["/images/hikes/cyclone1.jpg"],
    photos: ["/images/hikes/cyclone1.jpg", "/images/hikes/cyclone2.jpg", "/images/hikes/cyclone3.jpg"],
    youtubeVideo: "https://www.youtube.com/embed/Sp3apQcS7TQ?si=3TC0wEgQPExU2-0R",
    allTrails: "https://www.alltrails.com/widget/trail/us/washington/snowking-mountain?u=i&sh=ud7hlu",
    coordinates: "48.4731, -121.2328"
  },
  // {
  //   id: ,
  //   name: "",
  //   wildernessArea: "",
  //   length: , // miles
  //   dogsAllowed: true,
  //   highlights: "",
  //   permit: "",
  //   distanceFromSeattle: , // miles
  //   coverPhotos: ["/images/hikes/"],
  //   photos: ["/images/hikes/glacierpeak1.jpg"],
  //   youtubeVideo: "",
  // },
];
